import { Component } from '@angular/core';
import { AlertController, ModalController, ActionSheetController, PopoverController, NavController } from 'ionic-angular';
import * as firebase from 'firebase/app';
import { ChecksPage } from './checks/checks';
import { Params } from '../params';
import { CsvService } from "angular2-json2csv";
import { CustomerMenuPage } from './customer-menu/customer-menu';
import { CustomerPage } from './customer';
import { Events } from 'ionic-angular';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Http } from "@angular/http";
import { GlobalProvider } from "../../providers/global/global";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { MonthSelectorModal } from './month-selector-modal/month-selector-modal';

@Component({
  selector: 'page-customers',
  templateUrl: 'customers.html'
})
export class CustomersPage {
  items = [];
  //customersRef: FirebaseListObservable<any>;
  customers;
  foods = [];
  plans: any;
  filter_status: any = true;
  sort_value: any = 'nombre';
  money = Params.money;
  sorts = {
    day_price: true,
    name: true,
    discount: true,
    balance: true
  }
  old_foods = [];
  foods_ready = false;
  months: { name: string; value: number; }[];
  constructor(
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private _csvService: CsvService,
    public actionSheetCtrl: ActionSheetController,
    public popoverCtrl: PopoverController,
    private nav: NavController,
    public http: Http,
    public global: GlobalProvider,
    public events: Events
  ) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    this.foods = this.global.foods;
    /* firebase.database().ref('/foods').once('value').then((snapshot)=>{
      this.foods = snapshot.val();
    }); */

    firebase.database().ref('/plans').once('value').then((snapshot) => {
      this.plans = snapshot.val();
    });

    firebase.database().ref('/foods').once('value')
      .then((snap) => {
        this.old_foods = snap.val();
        this.foods_ready = true;
      });

    events.subscribe('foods:ready', () => {
      firebase.database().ref('/customers').once('value').then((snap) => {
        const val = snap.val();
        this.processCustomers(val);
      });
    });

    firebase.database().ref('/customers').on('value', (snap) => {
      const val = snap.val();
      this.processCustomers(val);
    });
    this.months = this.getMonths();
  }

  private getMonths(): Array<{ name: string, value: number }> {
    let months = [];
    for (let i = 1; i <= 12; i++) {
      let monthName = new Date(0, i, 0).toLocaleString('es', { month: 'long' });
      months.push({ name: monthName, value: i });
    }
    return months;
  }

  presentPopover(ev, cust) {
    if (this.foods_ready) {
      let popover = this.popoverCtrl.create(CustomerMenuPage, {
        customer: cust,
        foods: this.foods,
        old_foods: this.old_foods,
        plans: this.plans
      });

      popover.present({
        ev: ev
      });
    } else {
      let alert = this.alertCtrl.create({
        title: 'Espere porfavor',
        buttons: ['Ok']
      });
      alert.present();
    }

  }

  processCustomers(val) {
    console.log('🌟 -> file: customers.ts:103 -> CustomersPage -> processCustomers -> val', val)

    this.customers = Object.keys(val).map(key => ({ id: key, ...val[key] }));
    console.log(this.customers);
    this.initializeItems();
    this.filter(false);
    if (this.items.length > 100) { this.items = this.items.splice(0, 100); }
  }

  newCustomer(cust) {
    this.nav.push(CustomerPage, { customer: cust, foods: this.foods, plans: this.plans });
  }

  addMetrics(cust) {
    console.log("user", cust);
    let modal = this.modalCtrl.create(ChecksPage, { user: cust });
    modal.present();
  }

  restrictionsXls() {
    let data = [];
    for (let c of this.customers) {
      if (c.restrictions) {
        for (let r of Object.keys(c.restrictions)) {
          let restriction = c.restrictions[r];
          let item = {
            "Activo": c.active ? 'Si' : 'No',
            "Cliente": c.name + ' ' + c.lastname,
            "Email": c.email,
            "Plan": c.plan,
            "Alimento": restriction.value_name,
            "alimento_cod": restriction.value,
            "Tipo": this.typesRestrictions(restriction.type),
            "tipo_cod": restriction.type,
            "Motivo": restriction.reason,
            "Fecha": moment(restriction.datetime).format('DD-MM-YYYY'),
          };
          data.push(item);
        }
      }
    }
    // this._csvService.download(data, 'Restricciones_'+new Date().toJSON());
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout: string = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    FileSaver.saveAs(new Blob([wbout]), 'Restricciones-' + moment().format('DDMMYYYY') + '.xlsx');
  }

  typesRestrictions(type) {
    let name;
    if (type == 1) name = 'Ingrediente';
    if (type == 2) name = 'Grupo de Ingredientes';
    if (type == 3) name = 'Receta';
    return name;
  }

  restrictions(all) {
    let match = false;
    let texts = [];
    for (let i = 0; i < this.customers.length; i++) {
      let c = this.customers[i];
      if (c.restrictions) {
        if (all || (!all && c.active)) {
          match = true;
          let cnd = Object.keys(c.restrictions);
          texts.push(c.name + ' ' + c.lastname + ' tiene las siguientes restricciones:');
          for (let d = 0; d < cnd.length; d++) {
            texts.push(c.restrictions[cnd[d]].value_name + ' [' + c.restrictions[cnd[d]].value + '] por ' + c.restrictions[cnd[d]].reason);
          }
          texts.push('**');
        }
      }
    }
    if (match) {
      let de = {
        content: [],
        styles: {
          table: {
            "fontSize": 8,
            "margin": [0, 5, 0, 15],
          }
        }
      };
      de.content.push({ text: "Listado Restricciones Alimenticias FitFood.", bold: true, fontSize: 14 });
      de.content.push({ text: '', margin: [0, 22, 0, 8] });
      for (let t = 0; t < texts.length; t++) {
        if (texts[t] == "**") {
          de.content.push({ text: '', margin: [0, 22, 0, 8] });
        } else {
          de.content.push({
            text: texts[t],
            fontSize: 10
          });
        }
      }
      pdfMake.createPdf(de).open();

    } else {
      let alert = this.alertCtrl.create({
        title: 'No hay restricciones',
        subTitle: 'No existen clientes con restricciones',
        buttons: ['Aceptar']
      });
      alert.present();
    }
  }

  conditions(type) {
    let match = false;
    let texts = [];
    for (let i = 0; i < this.customers.length; i++) {
      let c = this.customers[i];
      if (c.conditions && c.active) {
        match = true;
        let cnd = Object.keys(c.conditions);
        if (type == 'pdf') {
          texts.push(c.name + ' ' + c.lastname + ' tiene las siguientes condiciones:');
          for (let d = 0; d < cnd.length; d++) {
            texts.push(this.foods[cnd[d]].name + ' : ' + c.conditions[cnd[d]]);
          }
          texts.push('**');
        } else if (type == 'csv') {
          for (let d = 0; d < cnd.length; d++) {
            texts.push({
              "Cliente": Params.parse_xls(c.name + ' ' + c.lastname),
              "Comida": Params.parse_xls(this.foods[cnd[d]].name),
              "Condicion": Params.parse_xls(c.conditions[cnd[d]])
            })
          }

        }

      }
    }
    if (match && type == 'pdf') {
      let de = {
        content: [],
        styles: {
          table: {
            "fontSize": 8,
            "margin": [0, 5, 0, 15],
          }
        }
      };
      de.content.push({ text: "Listado Condiciones Alimenticias FitFood.", bold: true, fontSize: 14 });
      de.content.push({ text: '', margin: [0, 22, 0, 8] });
      for (let t = 0; t < texts.length; t++) {
        if (texts[t] == "**") {
          de.content.push({ text: '', margin: [0, 22, 0, 8] });
        } else {
          de.content.push({
            text: texts[t],
            fontSize: 10
          });
        }
      }
      pdfMake.createPdf(de).open();

    } else if (match && type == 'csv') {
      this._csvService.download(texts, 'Condiciones_' + new Date().toJSON());
    } else {
      let alert = this.alertCtrl.create({
        title: 'No hay condiciones',
        subTitle: 'No existen clientes con condiciones',
        buttons: ['Aceptar']
      });
      alert.present();
    }
  }

  initializeItems() {
    let cloned = this.customers.map(x => Object.assign({}, x));
    this.items = cloned;
  }


  sort(param, numeric) {
    this.filter(false);
    this.sorts[param] = !this.sorts[param];
    if (numeric) {
      this.items.sort((a, b) => {
        if (this.sorts[param]) {
          if (Number(a[param]) < Number(b[param])) {
            return 1;
          } else if (Number(a[param]) > Number(b[param])) {
            return -1;
          }
        } else {
          if (Number(a[param]) > Number(b[param])) {
            return 1;
          } else if (Number(a[param]) < Number(b[param])) {
            return -1;
          }
        }

      });
    } else {
      this.items.sort((a, b) => {
        if (this.sorts[param]) {
          if (a[param] < b[param]) {
            return 1;
          } else if (a[param] > b[param]) {
            return -1;
          }
        } else {
          if (a[param] > b[param]) {
            return 1;
          } else if (a[param] < b[param]) {
            return -1;
          }
        }

      });
    }
    if (this.items.length > 100) { this.items = this.items.splice(0, 100); }
  }

  openMonthSelectorModal() {
    let modal = this.modalCtrl.create(MonthSelectorModal, { customers: this.customers });
    modal.onDidDismiss(selectedMonth => {
      if (selectedMonth) {
        console.log("El mes seleccionado es: ", selectedMonth);
        // Aquí puedes realizar el filtrado
      }
    });
    modal.present();
  }

  export() {
    const actionSheet = this.actionSheetCtrl.create({
      title: '¿Qué desea exportar?',
      buttons: [
        {
          text: 'Filtrar por Cumpleaños',
          handler: () => {
            setTimeout(() => {
              this.openMonthSelectorModal();
            }, 0);
          }
        },
        {
          text: 'Clientes en XLS',
          handler: () => {
            this.xls()
          }
        }, {
          text: 'Condiciones en PDF',
          handler: () => {
            this.conditions('pdf');
          }
        }, {
          text: 'Restricciones en XLS',
          handler: () => {
            this.restrictionsXls();
          }
        }, {
          text: 'Restricciones de todos en PDF',
          handler: () => {
            this.restrictions(true);
          }
        }, {
          text: 'Restricciones activos en PDF',
          handler: () => {
            this.restrictions(false);
          }
        }, {
          text: 'Condiciones en XLS',
          handler: () => {
            this.conditions('csv');
          }
        }, {
          text: 'Cancelar',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  xls() {
    let ok = [];


    for (let i = 0; i < this.customers.length; i++) {
      let c = this.customers[i];
      let s = {
        "Cliente": Params.parse_xls(c.name) + " " + Params.parse_xls(c.lastname),
        "Rut": c.rut ? c.rut : 'sin datos',
        "Email": c.email ? c.email : 'sin datos',
        "Direccion": c.address ? Params.parse_xls(c.address) + ", " + Params.parse_xls(c.address_info) : 'sin datos',
        "Fecha de Nacimiento": c.birth ? c.birth : 'sin datos',
        "Condicion": c.condition ? c.condition : 'sin datos',
        "Comidas": c.foods ? c.foods : 'sin datos',
        "Telefono": c.phone ? c.phone : 'sin datos',
        "Plan": c.plan ? c.plan : 'sin datos',
        "Ruta": c.route ? c.route : 'sin datos',
        "Ruta Posicion": c.route_pos ? c.route_pos : 'sin datos',
        "Activo": c.active ? 'si' : 'no',
        "Ruta Observaciones": c.route_obs ? c.route_obs : 'sin datos',
        "Sexo": c.sexo ? c.sexo : 'sin datos',
        "Altura": c.tall ? c.tall : 'sin datos',
        "Fecha de Ingeso": c.datestart ? c.datestart : 'sin datos',
        "Valor Diario": this.money(c.day_price),
        //"Descuento": c.discount ? c.discount+"%" : "0%",
        "Delivery": c.delivery ? c.delivery + " comidas" : 'sin datos',
        "id": c.id
      };
      ok.push(s);
    }
    console.log(ok);
    this._csvService.download(ok, 'Clientes_' + new Date().toJSON());
  }

  planName(code) {
    if (typeof this.plans != "undefined") {
      return this.plans[code] ? this.plans[code].name : '';
    } else {
      return '';
    }
  }

  filter(doit) {
    console.log(this.filter_status);
    if (this.filter_status === 'Todos') this.filter_status = null;
    this.initializeItems();
    if (this.filter_status != null) {
      this.items = this.items.filter((item) => {
        return (item.active == this.filter_status);
      });
    }
    if (doit) if (this.items.length > 100) { this.items = this.items.splice(0, 100); }
  }

  fixed(d) {
    return Number(d).toFixed(2)
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      if (this.filter_status != null) {
        this.items = this.items.filter((item) => {
          return (
            (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.rut.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.email.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.address.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.address_info.toLowerCase().indexOf(val.toLowerCase()) > -1)
          ) && item.active == this.filter_status
        })
      } else {
        this.items = this.items.filter((item) => {
          return (
            (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.rut.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.email.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.address.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
            (item.address_info.toLowerCase().indexOf(val.toLowerCase()) > -1)
          )
        })
      }
    } else {
      if (this.filter_status != null) this.filter(false);
    }
    if (this.items.length > 100) { this.items = this.items.splice(0, 100); }
  }

}



// WEBPACK FOOTER //
// ./src/pages/customers/customers.ts